import type { SingleView } from '../../core/view-manager/single-view.js';
import type { TableViewSelectionWithType } from './selection.js';

export function isTableSelectionWithinCanonicalBounds(
  view: SingleView,
  selection?: TableViewSelectionWithType
): boolean {
  if (!selection || selection.selectionType === 'row') {
    return true;
  }

  const { columnIndex, rowIndex } = selection.focus;
  if (
    !Number.isInteger(rowIndex) ||
    rowIndex < 0 ||
    rowIndex >= view.rowCount$.value
  ) {
    return false;
  }

  const canonicalColumnCount =
    view.columnCount$.value === 0
      ? 0
      : view.getPropertiesWindow({
          limit: view.columnCount$.value,
          offset: 0,
        }).properties.length;
  return (
    Number.isInteger(columnIndex) &&
    columnIndex >= 0 &&
    columnIndex < canonicalColumnCount
  );
}
